import type {
  ExecutionStatusKey,
  FeatureStatus,
  ReleaseStatus,
  SuiteRunStatus,
  TestRunStatus,
} from './dtos';

export type TestRunSummaryDto = {
  testId: string;
  testName?: string | null;
  displayName?: string | null;
  groupPath?: string[];
  suiteName?: string | null;
  suiteDisplayName?: string | null;
  testSlug?: string | null;
  status?: TestRunStatus | null;
  executionId?: string | null;
  runNumber?: number | null;
  timestamp?: Date | null;
};

export type SuiteRunSummaryDto = {
  suiteId: string;
  suiteName?: string | null;
  displayName?: string | null;
  suiteSlug?: string | null;
  status?: SuiteRunStatus | null;
  executionId?: string | null;
  runNumber?: number | null;
  timestamp?: Date | null;
};

export type ReleaseFeatureSummaryDto = {
  id: string;
  name?: string | null;
  slug?: string | null;
  status: FeatureStatus;
};

export type ReleaseSummaryItemDto = {
  id: string;
  name?: string | null;
  slug?: string | null;
  status: ReleaseStatus;
};

export type ReleaseSuiteSummaryDto = {
  id: string;
  name?: string | null;
  slug?: string | null;
};

export type ReleaseTestSummaryDto = {
  id: string;
  name?: string | null;
  slug?: string | null;
};

export type ExecutionStatusCounts = {
  total: number;
  passed: number;
  failed: number;
  errored: number;
  skipped: number;
  untested: number;
};

export const countExecutionStatuses = (
  statuses: Array<
    | ExecutionStatusKey
    | FeatureStatus
    | ReleaseStatus
    | SuiteRunStatus
    | TestRunStatus
    | null
    | undefined
  >,
): ExecutionStatusCounts => {
  const counts: ExecutionStatusCounts = {
    total: 0,
    passed: 0,
    failed: 0,
    errored: 0,
    skipped: 0,
    untested: 0,
  };
  statuses.forEach((status) => {
    counts.total += 1;
    if (!status) {
      counts.untested += 1;
      return;
    }
    if (status === 'passed') counts.passed += 1;
    else if (status === 'failed') counts.failed += 1;
    else if (status === 'errored') counts.errored += 1;
    else if (status === 'skipped') counts.skipped += 1;
    else counts.untested += 1;
  });
  return counts;
};
